module.exports = __webpack_public_path__ + "static/headerhero@2x-d71d1d86506f3034b44e08575235a887.jpg";